import React from 'react';
import styles from './search-result-title.module.scss';

type Props = {
  searchTitle: string;
  countOfResult: number;
};

export default function SearchTitle({ searchTitle, countOfResult }: Props) {
  const isSearchTitleProvided = searchTitle?.length > 0;

  return (
    <h4 className={`${styles[`search-title`]} font-family-lato mb-0`}>
      {countOfResult} results
      {isSearchTitleProvided && (
        <>
          &nbsp;for: <strong>&quot;{searchTitle}&quot;</strong>
        </>
      )}
    </h4>
  );
}
